import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPinIcon, LockIcon, ArrowUpRightIcon, BriefcaseIcon } from 'lucide-react';
import { Job, formatPosted } from '../../lib/data';
export function JobCard({
  job
}: {
  job: Job;
}) {
  return <motion.div whileHover={{
    y: -4
  }} transition={{
    duration: 0.3,
    ease: [0.16, 1, 0.3, 1]
  }} className="group relative flex h-full flex-col rounded-2xl border border-ink/10 bg-ivory-50 p-6 shadow-soft transition-shadow duration-300 hover:border-gold/50 hover:shadow-lift sm:p-7" data-id="element-188" data-mp="3lf5vf42yzbk2">
      <div className="flex items-start justify-between gap-4" data-id="element-189" data-mp="36hn1lnbfq85r">
        <div data-id="element-190" data-mp="36jzrcmnfpmtd">
          <div className="flex items-center gap-2" data-id="element-191" data-mp="36jq251a7rjoq">
            <span className="text-xs font-medium uppercase tracking-widest2 text-gold-dark" data-id="element-192" data-mp="31qdbympvz4tv">
              {job.type}
            </span>
            {job.confidential && <span className="inline-flex items-center gap-1 rounded-full bg-ink/5 px-2 py-0.5 text-[10px] font-medium text-ink-600" data-id="element-193" data-mp="2a0ioywpi3r8d">
                <LockIcon className="h-2.5 w-2.5" data-id="element-194" data-mp="2yjyfils7j8bo" /> Confidential
              </span>}
          </div>
          <h3 className="mt-3 font-serif text-xl leading-snug text-ink" data-id="element-195" data-mp="33hrn9j95sae2">
            <Link to={`/opportunities/${job.id}`} className="after:absolute after:inset-0" data-id="element-196" data-mp="38bm146231v58">
              {job.title}
            </Link>
          </h3>
          <p className="mt-1 text-sm text-ink-600" data-id="element-197" data-mp="2fln8k0oojfvt">
            {job.confidential ? 'Confidential Client' : job.company}
          </p>
        </div>
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-ink/10 text-ink-500 transition-all duration-300 group-hover:border-gold group-hover:bg-gold group-hover:text-ink" data-id="element-198" data-mp="2klhxhyow9ve8">
          <ArrowUpRightIcon className="h-4 w-4" data-id="element-199" data-mp="2uk7ii0c37vyp" />
        </span>
      </div>

      <p className="mt-4 line-clamp-2 flex-1 text-sm leading-relaxed text-ink-600" data-id="element-200" data-mp="4sj2mk349pc8">
        {job.summary}
      </p>

      <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-ink/10 pt-4 text-xs text-ink-500" data-id="element-201" data-mp="9r41og6mu2z3">
        <span className="inline-flex items-center gap-1.5" data-id="element-202" data-mp="25xmup1ul0ofi">
          <MapPinIcon className="h-3.5 w-3.5 text-gold-dark" data-id="element-203" data-mp="20vxgjdc2bun7" />
          {job.location}
        </span>
        <span className="inline-flex items-center gap-1.5" data-id="element-204" data-mp="2ev6zgkrnl2uv">
          <BriefcaseIcon className="h-3.5 w-3.5 text-gold-dark" data-id="element-205" data-mp="2av69q3z3t58i" />
          {job.remote}
        </span>
        <span className="ml-auto text-ink-400" data-id="element-206" data-mp="1n4sp2yium8ny">{formatPosted(job.postedDays)}</span>
      </div>
    </motion.div>;
}